import styles from './CatalogSliderCard.module.css';
import { Link } from 'react-router-dom';

export const CatalogSliderCard = ({ title, disc, img }) => {
	return (
		<Link to={`/catalog/category?type=${encodeURIComponent(title)}`}>
			<div className={styles.main} style={{ backgroundImage: `url(${img})` }}>
				{disc && <div>Скидка 50%</div>}
			</div>
			<h3>{title}</h3>
		</Link>
	);
};
